import { api } from '../config/base-api';
interface GetUnitsParams {
  country: string;
  brand: string;
  region: string;
  city: string;
  recurringSaleAllowed?: boolean;
}

export interface GetUnitsResponse {
  /** Esse ID é o accountId da unidade selecionada */
  salesforceId: string;
  name: string;
}

export async function getUnits({
  brand,
  country,
  region,
  city,
  recurringSaleAllowed,
}: GetUnitsParams): Promise<GetUnitsResponse[]> {
  const res = await api.get<GetUnitsResponse[]>('/api/v1/franchises/units', {
    params: {
      brand,
      country,
      region,
      city,
      ...(recurringSaleAllowed !== undefined && { recurringSaleAllowed }),
    },
  });

  return res.data;
}
